/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { createContext } from "react";

type AlertContextType = {
  show: boolean;
  message: any;
  type: any;
  showAlert: (message: any,type:any) => void;
  hideAlert: (e : any) => void;
};

export const AlertContext = createContext<AlertContextType>({
  show: false,
  message: "",
  type: "",
  showAlert: (message: any,type:any) => {},
  hideAlert: (e : any) => {},
});